/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Verif_3Inputs */

const en_mk_loop_verif_3 = /** @type {(inputs: Mk_Loop_Verif_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI — a GitHub Actions webhook becomes the official evidence`)
};

const id_mk_loop_verif_3 = /** @type {(inputs: Mk_Loop_Verif_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI — webhook GitHub Actions menjadi bukti resmi`)
};

/**
* | output |
* | --- |
* | "CI — a GitHub Actions webhook becomes the official evidence" |
*
* @param {Mk_Loop_Verif_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_verif_3 = /** @type {((inputs?: Mk_Loop_Verif_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Verif_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_verif_3(inputs)
	return en_mk_loop_verif_3(inputs)
});